import type React from 'react';
import type { PropsWithChildren } from 'react';

import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import st from './GeneralEventInfoRow.module.sass';

interface GeneralEventInfoRowProps extends PropsWithChildren, WithClassNameProp, WithDataTestid {
  title: string;
  titleClassName?: string;
}

function GeneralEventInfoRow({
  title,
  className = undefined,
  children = undefined,
  'data-testid': dataTestId = undefined,
  titleClassName = undefined,
}: GeneralEventInfoRowProps): React.JSX.Element {
  return (
    <div
      className={cn(st.GeneralEventInfoRow, className)}
      data-testid={dataTestId}
    >
      <span
        className={cn(st.Title, titleClassName)}
      >
        {title}
      </span>
      <div className={st.Children}>{children ?? <span className={st.Empty}>-</span>}</div>
    </div>
  );
}

export { GeneralEventInfoRow };
